export default __webpack_public_path__ + "static/packing2-5525c4bc6229ac3870f35cda9cc42dc3.jpg";